import { IRtpSettlementTransaction } from '../../interfaces/settlement/rtp-settlement-transaction.interface';

export abstract class AbstractRtpSettlementService {
  abstract getTransactionsByRespondentAndCycle(
    respondentRtn: string,
    cycleDate: string,
    reconWindowId: number
  ): Promise<IRtpSettlementTransaction[] | undefined>;
}
